import {
  CLEAR_FETCH_POLICIES_AD_STATES,
  FETCH_POLICIES_AD_FAILURE,
  FETCH_POLICIES_AD_SUCCESS,
  REQUEST_POLICIES_FETCH_AD,
} from "./policies.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const fetchPoliciesAdReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_POLICIES_FETCH_AD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_POLICIES_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };
    case FETCH_POLICIES_AD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };
    case CLEAR_FETCH_POLICIES_AD_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };
    default:
      return state;
  }
};
export default fetchPoliciesAdReducer;
